export default class fadeInOnIntersection {
  constructor() {
    this.init();
  }
  init() {
    const boxes = document.querySelectorAll("[data-intersection]");
    const boxesArray = Array.prototype.slice.call(boxes, 0);
    const options = {
      root: null,
      rootMargin: "0px 50%",
      threshold: 0.2,
    };
    const observer = new IntersectionObserver(doWhenIntersect, options);
    boxesArray.forEach(function (box) {
      observer.observe(box);
    });

    function doWhenIntersect(entries) {
      const entriesArray = Array.prototype.slice.call(entries, 0);
      entriesArray.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-display");
        }
      });
    }
  }
}
